export default __webpack_public_path__ + "static/media/ss1.891a64b0.jpg";